import React, { useCallback, useEffect } from 'react';
import {
  useMessageInputContext,
  useMessageComposer,
  useMessageComposerHasSendableData,
} from 'stream-chat-react';
import { useTranslation } from 'react-i18next';
import styles from './EditCommentBox.module.scss';
import { CommentBox } from '.';

const EditSendButton = () => {
  const { t } = useTranslation();
  const hasSendableData = useMessageComposerHasSendableData();

  return (
    <button
      className={styles.sendButton}
      data-testid="send-button-edit-form"
      disabled={!hasSendableData}
      type="submit"
    >
      {t('shared.workOrder.comments.message.send')}
    </button>
  );
};

export const EditCommentBox = () => {
  const { t } = useTranslation();
  const messageComposer = useMessageComposer();
  const { clearEditingState, handleSubmit } =
    useMessageInputContext('EditCommentBox');

  const cancel = useCallback(() => {
    clearEditingState?.();
    messageComposer.restore();
  }, [clearEditingState, messageComposer]);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') cancel();
    };

    document.addEventListener('keydown', onKeyDown);

    return () => document.removeEventListener('keydown', onKeyDown);
  }, [cancel]);

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <CommentBox />
      <div className={styles.editActionsContainer}>
        <button
          className={styles.cancelButton}
          data-testid="cancel-button"
          onClick={cancel}
          type="button"
        >
          {t('shared.workOrder.comments.message.cancel')}
        </button>
        <EditSendButton />
      </div>
    </form>
  );
};
